import axios from "axios";
import React, { useEffect, useState } from "react";
import { HiPrinter } from "react-icons/hi";
import { HiArrowDownTray } from "react-icons/hi2";
import { BsArrowClockwise, BsClockHistory } from "react-icons/bs";
import { MdPunchClock } from "react-icons/md";
import { base_url } from "../../utils/AxiosConfig";
import SnackbarNotification from "../../utils/SnackbarNotification";
import { base_url_image_view_api } from "../../utils/ImageViewingAPI";
import user1 from "../../images/ic_no_person_photo.svg";
import dayjs from "dayjs";
import { BiCheckCircle } from "react-icons/bi";
import { FallingLines } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";
import { FaSearch } from "react-icons/fa";

import { LuPanelLeftOpen, LuPanelRightOpen } from "react-icons/lu";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { base_url as base_url_from_axios_config } from "../../utils/AxiosConfig";
import { set } from "date-fns";

const AttendancePunchDetailsReport = () => {
  const [selectedEmp, setSelectedEmp] = useState(null);
  const [selectedEmpID, setSelectedEmpID] = useState("-");
  const [active, setActive] = useState("Yes");
  const [records, setRecords] = useState([]);
  const [searchdata, setSearchData] = useState("");
  // const [dept, setDept] = useState("ALL");
  const [dept, setDept] = useState("-");
  // const [department, setDepartment] = useState("ALL");
  const [department, setDepartment] = useState("-");
  // const [jobTitleSelected, setJobTitleSelected] = useState("ALL");
  const [jobTitleSelected, setJobTitleSelected] = useState("-");
  // const [selectedDivision, setSelectedDivision] = useState("ALL");
  const [selectedDivision, setSelectedDivision] = useState("-");
  const [dynamicSubTitle, setDynamicSubTitle] = useState("All Employee List");
  const [resetalldata, setResetallData] = useState(false);

  const [attendancePunchDetailsStartDate, setAttendancePunchDetailsStartDate] =
    useState(dayjs().format("YYYY-MM-DD"));
  // const [attendancePunchDetailsStartDate, setAttendancePunchDetailsStartDate] = useState(
  //   dayjs().startOf("month").format("YYYY-MM-DD"),
  // );
  const [attendancePunchDetailsEndDate, setAttendancePunchDetailsEndDate] =
    useState(
      dayjs().format("YYYY-MM-DD"),
      // dayjs().format("DD-MMM-YYYY"),
    );

  const [divisionListFromAPI, setDivisionListFromAPI] = useState([]);
  const [departmentListFromAPI, setDepartmentListFromAPI] = useState([]);
  const [deptListFromAPI, setDeptListFromAPI] = useState([]);
  const [jobTitleListFromAPI, setJobTitleListFromAPI] = useState();
  const [gradeListFromAPI, setGradeListFromAPI] = useState([]);
  const [grade, setGrade] = useState("-");
  const [loader, setLoader] = useState(true);
  const [
    shouldFetchAttendancePunchDetails,
    setShouldFetchAttendancePunchDetails,
  ] = useState(false);
  const [openChooseEmpId, setOpenChooseEmpId] = useState(false);
  const [allEmpRecords, setAllEmpRecords] = useState([]);

  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "success",
    message: "",
  });

  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  const companyCode = storedUserDataArray[0]?.cmpcode || null;

  useEffect(() => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }
    getDepartmentList(companyCode);
    getDeptList(companyCode);
    // getGradeList(companyCode);
    getDivisionList();
    getJobTitle(companyCode);
    getData(companyCode);
    onAttendancePunchDetails();
    // resetAttendancePunchDetailsFilters();
  }, []);

  // useEffect(() => {
  //   if (base_url && companyCode && jobTitleSelected && department && dept) {
  //     getData("YES");
  //   }
  // }, [
  //   base_url,
  //   // companyCode,
  //   // searchParams,
  //   searchdata,
  //   // selectedJob,
  //   // selectedgrade,
  //   active,
  //   setSelectedDivision,
  //   selectedDivision,
  //   resetalldata,
  //   jobTitleSelected,
  //   department,
  //   dept,
  // ]);

  const applyFilters = () => {
    getData();
  };

  useEffect(() => {
    if (selectedEmp) {
      setSelectedEmpID(selectedEmp?.EmpId);
    }
  }, [selectedEmp]);

  const getDivisionList = async () => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }

    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/DIVISION/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setDivisionListFromAPI(newArray.map((i) => i.Description));
    } else {
      console.log("error");
    }
  };

  const getDepartmentList = async () => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }

    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/DEPARTMENT/-`,
      // `${base_url}/api/MASTERLIST/CUBIX/DEPARTMENT/-`
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setDepartmentListFromAPI(newArray.map((i) => i.Description));
    } else {
      console.log("error");
    }
  };

  const getDeptList = async () => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }

    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/DEPT/-`,
      // `${base_url}/api/MASTERLIST/CUBIX/DEPT/-`
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      console.log("dept newArray", newArray);
      setDeptListFromAPI(newArray.map((i) => i.Description));
    } else {
      console.log("error");
    }
  };

  const getJobTitle = async (companyCode) => {
    try {
      const response = await axios.get(
        `${base_url}/api/MASTERLIST/${companyCode}/JOBTITLE/-`,
      );
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );
      console.log("JOBTITLE newArray from job title List:", newArray);
      const data = newArray.map((i) => i.Description);
      console.log("JOBTITLE  Data from job title List:", data);
      setJobTitleListFromAPI(data);
    } catch (error) {
      console.log("error while fetching job title list!", error);
    }
  };

  const showSnackbar = (severity, message) => {
    setSnackbar({ open: true, severity, message });
  };

  const handleClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const resetAttendancePunchDetailsFilters = () => {
    // setDepartment("ALL");
    setDepartment("-");
    // setDept("ALL");
    setDept("-");
    // setGrade("ALL");
    setGrade("-");
    // setJobTitleSelected("ALL");
    setJobTitleSelected("-");
    setSearchData("");
    setResetallData(true);
    // setDynamicSubTitle("All Employee List");
    // setAttendancePunchDetailsStartDate(dayjs().startOf("month").format("YYYY-MM-DD"));
    setAttendancePunchDetailsStartDate(dayjs().format("YYYY-MM-DD"));
    setAttendancePunchDetailsEndDate(dayjs().format("YYYY-MM-DD"));
    // setSelectedDivision("ALL");
    setSelectedDivision("-");
    setActive("Yes");
    setSelectedEmpID("-");
    // getData();
    setShouldFetchAttendancePunchDetails(true);
  };

  useEffect(() => {
    if (shouldFetchAttendancePunchDetails) {
      onAttendancePunchDetails();
      setShouldFetchAttendancePunchDetails(false);
    }
  }, [
    shouldFetchAttendancePunchDetails,
    department,
    dept,
    grade,
    jobTitleSelected,
    // searchdata,
    attendancePunchDetailsStartDate,
    attendancePunchDetailsEndDate,
    selectedDivision,
    active,
    selectedEmpID,
  ]);

  const getData = async () => {
    setLoader(true);
    try {
      const isSearchEmpty = !searchdata || searchdata.trim() === "";

      const searchType = isSearchEmpty || resetalldata ? "ALL" : "FREETEXT";
      const searchParam = isSearchEmpty || resetalldata ? "ALL" : searchdata;

      // const searchParam = resetalldata ? "ALL" : searchdata || "ALL";
      // const searchType = searchdata && !resetalldata ? "FREETEXT" : "ALL";

      const response = await axios.get(
        // `${base_url}/api/PersonalInfoList/${companyCode}/${searchType}/${empStatus}/${searchParam}/${jobTitleParam}/${gradeParam}/${divisionParam}`,

        // working static down..|
        `${base_url}/api/PersonalInfoList/${companyCode}/${searchType}/YES/${searchParam}/ALL/ALL/ALL`,

        // working dynamic down..|
        // `${base_url}/api/PersonalInfoList/${companyCode}/${searchType}/YES/${searchParam}/${jobTitleSelected}/ALL/${selectedDivision}`,
      );
      const data = response.data;
      console.log("Data Employee List:", data);
      // setRecords(data);
      setAllEmpRecords(data);
    } catch (error) {
      console.error("Error fetching data:", error);
      // toast.error("Error fetching employee data");
    } finally {
      setLoader(false);
      if (resetalldata) setResetallData(false);
    }
  };

  const fetchProfilePic = (ImagePath) => {
    if (!ImagePath) return user1;
    const filePath = ImagePath.replace(/\\/g, "/");
    const fileName = filePath.split("/").pop();
    return `${base_url_image_view_api}/BONDTIME_EMP_IMG/${fileName}`;
  };

  console.log("Selected Employee:", selectedEmp);
  // grade - Division
  // divion - department
  const onAttendancePunchDetails = async () => {
    try {
      // https://cubixweberp.com:213/api/CRMHrReports/CUBIX/OVERTIME/CBX005/Yes/-/-/-/-/2026-04-01/2026-04-01
      // working static
      // const apiURL = `${base_url}/api/CRMHrReports/${companyCode}/OVERTIME/${selectedEmpID}/${active}/-/-/-/-/${attendancePunchDetailsStartDate}/${attendancePunchDetailsEndDate}`;

      // working dynamic (Division means department)
      const apiURL = `${base_url}/api/CRMHrReports/${companyCode}/PUNCHEDETAILS/${selectedEmpID}/${active}/-/${jobTitleSelected}/${selectedDivision}/${department}/${attendancePunchDetailsStartDate}/${attendancePunchDetailsEndDate}`;
      // {compcode}/{mode}/{empid}/{active}/{freetext}/{jobtitle}/{grade}/{division}/{datefrom}/{dateto}
      // const apiURL = `${base_url}/api/CRMHrReports/${companyCode}/OVERTIME/${selectedEmpID}/${active}/-/${jobTitleSelected}/${selectedDivision}/-/${attendancePunchDetailsStartDate}/${attendancePunchDetailsEndDate}/${dept}`;
      const response = await axios.get(apiURL);
      const data = response.data;
      setRecords(data);
      console.log("Response of attendancePunchDetails summary:", data);
      setDynamicSubTitle("AttendancePunchDetails Summary");
    } catch (error) {
      console.error(
        "Error while getting attendancePunchDetails summary!",
        error,
      );
    }
  };

  const navigate = useNavigate();
  const attendancePunchDetailsReportPrint = () => {
    navigate("/admin/attendancePunchDetailsPrint", {
      state: { attendancePunchDetailsSummaryData: records },
    });
  };

  const handleExport = () => {
    const columns = [
      { field: "SL NO", headerName: "SL NO" },
      { field: ["EMP ID"], headerName: "EMP ID" },
      { field: "NAME", headerName: "NAME" },
      { field: ["JOB TITLE"], headerName: "JOB TITLE" },
      { field: "DEPARTMENT", headerName: "DEPARTMENT" },
      { field: "DIVISION", headerName: "DIVISION" },
      { field: "Time", headerName: "TIME" },
      { field: "Type", headerName: "TYPE" },
    ];

    exportToCSV(columns, records, "Attendance_Punch_Details");
  };

  const exportToCSV = (columns, exportData, exportFileName = "export") => {
    if (!columns || !exportData || exportData.length === 0) return;

    const headerRow = columns.map((col) => col.headerName);

    const dataRows = exportData.map((row, index) =>
      columns.map((col) => {
        if (col.field === "SL NO") return index + 1;

        let value = row[col.field] ?? "";

        if ((col.field === "IN_TIME" || col.field === "OUT_TIME") && value) {
          value = dayjs(value).format("HH:mm:ss");
        } else if (col.field === "DATE" && value) {
          value = dayjs(value).format("YYYY-MM-DD");
        }

        return `"${String(value).replace(/"/g, '""')}"`;
      }),
    );

    const csvContent = [headerRow, ...dataRows]
      .map((row) => row.join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `${exportFileName}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    if (searchdata) {
      getData();
    }
  }, [searchdata]);

  return (
    <div>
      <div className="flex items-center justify-between gap-2 mb-4 ">
        <div className="flex justify-between items-end mb-4 mr-2 ">
          {/* <h6 className="text-2xl mb-2 font-bold text-gray-600 flex  justify-start items-center">
          Payroll
        </h6> */}

          <div className="flex flex-col justify-between items-left gap-4">
            <div className="flex justify-left items-center">
              <div className="w-1 h-12 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full  mr-2"></div>
              <h6 className="text-xl font-bold text-gray-900 flex items-center gap-4">
                {/* <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-[#2663EB] to-blue-700 text-white shadow-lg">
      <MdPersonAddAlt className="w-7 h-7" />
      </span> */}
                <span className="bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
                  ATTENDANCE PUNCH DETAILS REPORT
                </span>
              </h6>
            </div>

            {/* <div className="flex justify-left items-center">
              <div className="w-1 h-4 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full  mr-2"></div>
              <h6 className="text-md font-semibold text-gray-900 flex items-center gap-4">
                {/* <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-[#2663EB] to-blue-700 text-white shadow-lg">
      <MdPersonAddAlt className="w-7 h-7" />
      </span> 
                <span className="bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
                  {dynamicSubTitle}
                </span>
              </h6>
            </div> */}
          </div>
        </div>
        {dynamicSubTitle == "All Employee List" ? (
          <div className="flex justify-between items-center gap-4">
            <div className="ml-4 mt-4 bg-white w-60 flex items-center gap-2 p-2  border border-gray-700 rounded-md transition-all duration-200  focus-within:ring-2 focus-within:ring-[#2663EB]/20 hover:shadow-md">
              <FaSearch className="text-gray-400 text-sm transition-colors duration-200 group-focus-within:text-[#2663EB]" />

              <input
                type="text"
                placeholder="Search By ID or Name..."
                value={searchdata}
                onChange={(e) => setSearchData(e.target.value)}
                className="w-full  outline-none text-sm text-gray-700 placeholder-gray-400"
              />

              {/* {searchdata && (
                <button
                  onClick={() => {
                    setSearchData("");
                    // getData();
                  }}
                  className="text-gray-400 hover:text-red-500 text-sm transition-colors"
                >
                  ✕
                </button>
              )} */}
            </div>
          </div>
        ) : (
          <div className="flex flex-col justify-left items-left gap-2 ml-4">
            <button
              onClick={() => attendancePunchDetailsReportPrint()}
              className="flex items-center gap-2 px-3 py-2 text-xs rounded-md bg-blue-600 text-white hover:bg-blue-700 transition-all duration-200 shadow-sm"
            >
              <HiPrinter className="text-sm" />
              Print Report
            </button>

            <button
              onClick={handleExport}
              className="flex items-center gap-2 px-3 py-2 text-xs rounded-md bg-emerald-600 text-white hover:bg-emerald-700 transition-all duration-200 shadow-sm"
            >
              <HiArrowDownTray className="text-sm" />
              Export Report
            </button>
          </div>
        )}

        <div className="flex justify-center items-end gap-4 ">
          <div className="flex flex-col justify-left items-left gap-1 ">
            <div>
              <label
                htmlFor="exampleInputEmail1"
                className="form-label fs-small text-secondary"
              >
                Selected Emp ID:
              </label>
              <div className="flex gap-1">
                <input
                  className="form-control cursor-not-allowed "
                  // value={selectedEmp?.EmpId}
                  value={selectedEmpID}
                  disabled
                />
                <button
                  // onClick={() => applyFilters()}
                  onClick={() => setOpenChooseEmpId(true)}
                  className="flex items-center gap-2 p-1 text-xs rounded-md bg-blue-500 text-white hover:bg-blue-700 transition-all duration-200 shadow-sm"
                >
                  <BiCheckCircle className="text-sm" />
                  Choose
                </button>
              </div>
            </div>
          </div>

          <div>
            <label className="block text-xs text-gray-600 ">Active</label>

            <select
              value={active || "-"}
              onChange={(e) => setActive(e.target.value)}
              className=" mb-2 w-full border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>

            <label className="block text-xs text-gray-600 mb-1">
              Job Title
            </label>

            <select
              value={jobTitleSelected || "-"}
              onChange={(e) => setJobTitleSelected(e.target.value)}
              className="w-full border border-gray-300 rounded px-2 py-1 pr-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="-">None</option>

              {jobTitleListFromAPI?.map((d, index) => (
                <option key={index} value={d}>
                  {d}
                </option>
              ))}
            </select>
          </div>

          <div className="flex flex-col justify-left items-left gap-1 ">
            <label className="block text-xs text-gray-600 ">Division</label>

            <select
              value={selectedDivision || "-"}
              onChange={(e) => setSelectedDivision(e.target.value)}
              className=" mb-2 w-full border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="-">None</option>

              {divisionListFromAPI?.map((b) => (
                <option key={b.DEPTNO} value={b}>
                  {b}
                </option>
              ))}
            </select>
            {/* <label className="block text-xs text-gray-600 ">Branch</label> */}
            <label className="block text-xs text-gray-600 ">Department</label>

            <select
              value={department || "-"}
              onChange={(e) => setDepartment(e.target.value)}
              className="w-full border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="-">None</option>

              {departmentListFromAPI?.map((b) => (
                <option key={b.DEPTNO} value={b}>
                  {b}
                </option>
              ))}
            </select>
          </div>

          {/* <FormControl variant="outlined" sx={{ minWidth: 180 }} size="small">
            <InputLabel id="department-select-label">Department</InputLabel>
            <Select
              labelId="department-select-label"
              value={dept}
              // onChange={(e) => handleChange(e, "department")}
              label="Department"
            >
              <MenuItem value="-">
                <em>None</em>
              </MenuItem>
              {deptListFromAPI?.map((dept) => (
                <MenuItem
                  // key={dept.id}
                  value={dept}
                  onClick={() => {
                    setDept(dept);
                    //   setSelectedDepartmentCode(dept.code);
                  }}
                >
                  {dept}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}

          {/* 
            <div className="mb-3">
              {/* <label className="block text-xs text-gray-600 mb-1">
                Department
              </label> 
              <label className="block text-xs text-gray-600 mb-1">Branch</label>

              <select
                value={dept || "-"}
                onChange={(e) => setDept(e.target.value)}
                className="w-full border border-gray-300 rounded px-2 py-1 pr-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="-">None</option>

                {deptListFromAPI?.map((d, index) => (
                  <option key={index} value={d}>
                    {d}
                  </option>
                ))}
              </select>
            </div> */}

          <div className="flex flex-col justify-left items-center">
            <div className="mb-2">
              <label
                htmlFor="exampleInputEmail1"
                className="form-label fs-small text-secondary"
              >
                Start Date
              </label>
              <input
                type="date"
                className="form-control"
                id="startDate"
                name="startDate"
                value={attendancePunchDetailsStartDate}
                onChange={(e) =>
                  setAttendancePunchDetailsStartDate(e.target.value)
                }
                max={new Date().toISOString().split("T")[0]}
              />
            </div>

            <div className="ms-2">
              <label
                htmlFor="exampleInputEmail1"
                className="form-label fs-small text-secondary"
              >
                End Date
              </label>
              <input
                type="date"
                className="form-control"
                id="endDate"
                name="endDate"
                value={attendancePunchDetailsEndDate}
                onChange={(e) =>
                  setAttendancePunchDetailsEndDate(e.target.value)
                }
                max={new Date().toISOString().split("T")[0]}
              />
            </div>
          </div>

          <div className="flex flex-col justify-left items-left gap-2">
            <div className="flex justify-between items-center">
              {/* <button
                onClick={() => applyFilters()}
                className="flex items-center gap-2 px-3 py-2 text-xs rounded-md bg-[#1DC7AD] text-white hover:bg-[#17b39c] transition-all duration-200 shadow-sm"
              >
                <BiCheckCircle className="text-sm" />
                Apply
              </button> */}
              {/* Reset */}
              <button
                onClick={() => resetAttendancePunchDetailsFilters()}
                className="flex items-center gap-2 px-3 py-2 text-xs rounded-md bg-gray-400 text-white hover:bg-gray-500 transition-all duration-200 shadow-sm"
              >
                <BsArrowClockwise className="text-sm" />
                Reset All
              </button>
            </div>

            {/* AttendancePunchDetails Summary */}
            <button
              onClick={onAttendancePunchDetails}
              className="flex items-center gap-2 px-3 py-2 text-xs rounded-md bg-purple-500 text-white hover:bg-purple-600 transition-all duration-200 shadow-sm"

              // className="flex items-center gap-2 px-3 py-2 text-xs rounded-md bg-violet-500 text-white hover:bg-violet-600 transition-all duration-200 shadow-sm"
            >
              <BsClockHistory className="text-sm" />
              Attendance Punch Details Report
            </button>
          </div>
        </div>
      </div>
      <div className="overflow-auto h-[68vh] max-w-85 scrollbar-none rounded-md pb-16">
        {records === null || records === undefined ? (
          // 🔄 LOADING
          <div className="flex flex-col items-center justify-center py-10 text-gray-500">
            <FallingLines />
            <p className="mt-3 text-sm">Please wait, loading report data...</p>
          </div>
        ) : records.length === 0 ? (
          // 📭 NO DATA
          <div className="flex flex-col items-center justify-center py-10 text-gray-400">
            <div className="flex flex-col items-center justify-center py-12 text-gray-400">
              <img src="" className="w-20 mb-3 opacity-70" />
              <p className="text-sm font-medium">No records found</p>
            </div>
            <p className="text-xs mt-1">
              Try adjusting filters or selecting a different date range.
            </p>
          </div>
        ) : (
          <>
            {/* <table className="table-auto w-full bg-white text-xs border-collapse border border-gray-300 shadow-sm rounded-md px-6 overflox-x-auto"> */}
            <table className="shadow-sm min-w-full  rounded-sm border border-[gray-300] text-xs ">
              <thead className="sticky top-0">
                <tr className="bg-[#2663EB] text-white">
                  <th className="px-1.5 py-1  font-normal">Sl No</th>
                  <th className="px-1.5 py-1   font-normal">Emp ID</th>
                  <th className="px-1.5 py-1   font-normal">Name</th>
                  {/* <th className="px-1.5 py-1   font-normal">Nationality</th> */}
                  <th className="px-1.5 py-1   font-normal">Job Title</th>
                  <th className="px-1.5 py-1   font-normal">Department</th>
                  <th className="px-1.5 py-1   font-normal">Division</th>
                  {records?.some((d) => d?.Time != null) && (
                    <th className="px-1.5 py-1 font-normal">Time</th>
                  )}
                  {records?.some((d) => d?.Type != null) && (
                    <th className="px-1.5 py-1 font-normal">Type</th>
                  )}
                </tr>
              </thead>
              <tbody className="text-sm text-gray-700">
                {records?.map((d, i) => {
                  const isSelected = selectedEmp?.EmpId === d?.EmpId;
                  return (
                    <tr
                      onClick={() => setSelectedEmp(d)}
                      key={d.EmpId || i}
                      className={`border transition-colors duration-150 ${isSelected ? "hover:bg-blue-100 bg-blue-50" : "hover:bg-gray-50 bg-white"} `}
                    >
                      <td className="px-3 py-2 whitespace-nowrap border border-gray-100">
                        {i + 1}
                      </td>
                      <td className="px-3 py-2 whitespace-nowrap border ">
                        {d?.EmpId || d["EMP ID"]}
                      </td>
                      <td className="px-3 py-2 whitespace-nowrap border">
                        <div className="flex items-center gap-2">
                          <img
                            className="w-7 h-7 rounded-full object-cover"
                            src={
                              d.imagepath ? fetchProfilePic(d.imagepath) : user1
                            }
                            alt=""
                          />
                          <span>{d?.Name || d?.NAME}</span>
                        </div>
                      </td>
                      {/* <td className="px-3 py-2 whitespace-nowrap border">
                        {d?.Nationality||d?.NATIONALITY}
                      </td> */}
                      <td className="px-3 py-2 whitespace-nowrap border">
                        {d?.JobTitle || d["JOB TITLE"]}
                      </td>
                      <td className="px-3 py-2 whitespace-nowrap border">
                        {d?.Department || d?.DEPARTMENT}
                      </td>
                      <td className="px-3 py-2 whitespace-nowrap border">
                        {d?.Division || d?.DIVISION}
                      </td>
                      {d?.Time != null && (
                        <td className="px-3 py-2 whitespace-nowrap border">
                          {d?.Time || "-"}
                        </td>
                      )}
                      {d?.Type != null && (
                        <td className="px-3 py-2 whitespace-nowrap border">
                          {d?.Type || "-"}
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </>
          // ) : (
          //   <div className="table-nodata-img">
          //     <div className="center">
          //       <p className="text-center pt-5">
          //         Please Wait Loading Data...
          //         <FallingLines />
          //       </p>
          //     </div>
          //   </div>
        )}
        <SnackbarNotification
          open={snackbar.open}
          severity={snackbar.severity}
          message={snackbar.message}
          onClose={handleClose}
        />
      </div>
      {openChooseEmpId && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          {/* Modal Container */}
          <div className="bg-white w-[90%] max-w-6xl rounded-lg shadow-lg p-4">
            {/* Header */}
            <div className="flex justify-between items-center mb-3">
              <h2 className="text-sm font-semibold">Select Employee</h2>
              <div className="flex justify-between items-center gap-4">
                <div className="ml-4 mt-4 bg-white w-60 flex items-center gap-2 p-2  border border-gray-700 rounded-md transition-all duration-200  focus-within:ring-2 focus-within:ring-[#2663EB]/20 hover:shadow-md">
                  <FaSearch className="text-gray-400 text-sm transition-colors duration-200 group-focus-within:text-[#2663EB]" />

                  <input
                    type="text"
                    placeholder="Search By ID or Name..."
                    value={searchdata}
                    onChange={(e) => setSearchData(e.target.value)}
                    className="w-full  outline-none text-sm text-gray-700 placeholder-gray-400"
                  />

                  {/* {searchdata && (
                    <button
                      onClick={() => setSearchData("")}
                      className="text-gray-400 hover:text-red-500 text-sm transition-colors"
                    >
                      ✕
                    </button>
                  )} */}
                </div>
              </div>
              <button
                onClick={() => setOpenChooseEmpId(false)}
                className="text-gray-500 hover:text-red-500 text-lg"
              >
                ✕
              </button>
            </div>

            {/* Table Wrapper (Scrollable) */}
            <div className="max-h-[400px] overflow-auto border rounded-md">
              <table className="min-w-full text-xs">
                <thead className="sticky top-0 bg-[#2663EB] text-white">
                  <tr>
                    <th className="px-2 py-2 font-normal">Sl No</th>
                    <th className="px-2 py-2 font-normal">Emp ID</th>
                    <th className="px-2 py-2 font-normal">Name</th>
                    <th className="px-2 py-2 font-normal">Nationality</th>
                    <th className="px-2 py-2 font-normal">Job Title</th>
                    <th className="px-2 py-2 font-normal">Department</th>
                    <th className="px-2 py-2 font-normal">Division</th>
                  </tr>
                </thead>

                <tbody className="text-gray-700">
                  {allEmpRecords?.map((d, i) => {
                    const isSelected = selectedEmp?.EmpId === d?.EmpId;

                    return (
                      <tr
                        key={d.EmpId || i}
                        onClick={() => {
                          setSelectedEmp(d);
                        }}
                        className={`cursor-pointer transition ${
                          isSelected
                            ? "bg-blue-100 hover:bg-blue-200"
                            : "hover:bg-gray-50"
                        }`}
                      >
                        <td className="px-2 py-2 border">{i + 1}</td>
                        <td className="px-2 py-2 border">
                          {d?.EmpId || d["EMP ID"]}
                        </td>

                        <td className="px-2 py-2 border">
                          <div className="flex items-center gap-2">
                            <img
                              className="w-7 h-7 rounded-full object-cover"
                              src={
                                d.imagepath
                                  ? fetchProfilePic(d.imagepath)
                                  : user1
                              }
                              alt=""
                            />
                            <span>{d?.Name || d?.NAME}</span>
                          </div>
                        </td>

                        <td className="px-2 py-2 border">
                          {d?.Nationality || d?.NATIONALITY}
                        </td>

                        <td className="px-2 py-2 border">
                          {d?.JobTitle || d["JOB TITLE"]}
                        </td>

                        <td className="px-2 py-2 border">
                          {d?.Department || d?.DEPARTMENT}
                        </td>

                        <td className="px-2 py-2 border">
                          {d?.Division || d?.DIVISION}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* Footer Actions */}
            <div className="flex justify-end mt-3 gap-2">
              <button
                onClick={() => setOpenChooseEmpId(false)}
                className="px-3 py-1 text-xs bg-gray-200 rounded hover:bg-gray-300"
              >
                Cancel
              </button>

              <button
                onClick={() => {
                  // handle select
                  setOpenChooseEmpId(false);
                }}
                className="px-3 py-1 text-xs bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Select
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AttendancePunchDetailsReport;
